import React, { useState } from 'react';
import { Bill, BillConceptos, FiscalpopImpuesto } from '../../../models/Factura';
import Button from '../../Forms/Button';
import { useQuery } from '@apollo/react-hooks';
import { graphqlSchema } from '../../../services/graphql.schema';
import { clearGqlTypename } from '../../../utils/formatting';
import { ConceptoElementDevolucion } from './Factura.devolucion.element';
import { EMPTY_CONCEPTO_DEVOLUCION } from './Factura.devolucion.empty';

interface FacturarConceptoProps {
    cfdi: Bill;
    validRequested: boolean;
    authToken: string;
    // Emitters
    onCfdiChange: (value: BillConceptos[]) => void;

}

function FacturarConceptosDevolucion({ cfdi, onCfdiChange, validRequested, authToken }: FacturarConceptoProps) {
    const [impuestosList, setImpuestosList] = useState([]);
    useQuery(graphqlSchema.FISCALPOP.IMPUESTOS.getImpuestos, {
        onCompleted: ({ getImpuestos }: { getImpuestos: FiscalpopImpuesto[] }) => {
            console.log('Get Impuestos: ', getImpuestos);
            // For now, filter exento out, unknown if it will be used or if it can be used in credit notes
            setImpuestosList(getImpuestos.filter(c => !c.exento).map(c => clearGqlTypename(c)));
        },
        onError: (e) => {
            console.error('Error loading impuestos: ', e);
        },
        fetchPolicy: 'cache-first'
    })

    const updateConceptoElement = (index: number) => (update: BillConceptos) => {
        const conceptosCommon = cfdi.conceptos;
        console.log('Pre-Updating conceptosCommon: ', JSON.parse(JSON.stringify(conceptosCommon)));
        conceptosCommon[index] = update;
        console.log('Updating concepto Index: ', index);
        console.log('Updating conceptosCommon: ', JSON.parse(JSON.stringify(conceptosCommon)));
        onCfdiChange(conceptosCommon);
    }

    const addNewConcepto = () => {
        const conceptosCommon = cfdi.conceptos;
        conceptosCommon.push(EMPTY_CONCEPTO_DEVOLUCION());
        onCfdiChange(conceptosCommon);
    }

    const removeConcepto = (index: number) => () => {
        const conceptosCommon = cfdi.conceptos;
        conceptosCommon.splice(index, 1);
        onCfdiChange(conceptosCommon);
    }

    return (
        <div id="_Conceptos_Block">
            <h4>Conceptos</h4>
            <div className="card table">
                <div className="cardBody">
                    {
                        cfdi.conceptos.map((concepto, i) =>
                        (
                            <ConceptoElementDevolucion
                                key={i}
                                conceptoIndex={i}
                                concepto={concepto}
                                authToken={authToken}
                                removeConcepto={removeConcepto}
                                validRequested={validRequested}
                                impuestosList={impuestosList}
                                handleConceptoUpdate={updateConceptoElement} />
                        )
                        )
                    }
                    <div className="row">
                        <Button tertiary={true} handleClick={addNewConcepto}>
                            <span>Agregar otra devolución</span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FacturarConceptosDevolucion;
